import { render, staticRenderFns } from "./StageImage.vue?vue&type=template&id=5672cde9"
import script from "./StageImage.vue?vue&type=script&lang=js"
export * from "./StageImage.vue?vue&type=script&lang=js"
import style0 from "./StageImage.vue?vue&type=style&index=0&id=5672cde9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports